import { supabase } from "../supabaseClient";

export async function saveProject(projectData) {
  const payload = {
    name: projectData.nomProjet || "Projet sans nom",
    client_name: projectData.nomClient || "Client sans nom",
    status: "étude",
    budget: Number(projectData.montantGlobal || 0),
    start_date: null,
    end_date: null,
  };

  const { data, error } = await supabase
    .from("projects")
    .insert([payload])
    .select();

  if (error) {
    console.error("Erreur Supabase :", error);
    return null;
  }

  return data;
}